// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import BAGPAGE_CONSTANTS from '../../BagPage/BagPage.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const NonCachedCartReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case BAGPAGE_CONSTANTS.CLEAR_NON_CACHED_CART_DATA_TTL:
      return state.set(DEFAULT_REDUCER_KEY, null);
    case BAGPAGE_CONSTANTS.SET_NON_CACHED_CART_DATA_TTL:
      return state.set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload));
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default NonCachedCartReducer;
